export * from './delete-foto-kategorie-request.interface';
export * from './delete-foto-kategorie-response.interface';
export * from './delete-foto-kategorie.shapes';
